import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Layers } from 'lucide-react';

const SeriesList = ({ seriesList, selectedSeries, onSelectSeries }) => {
  if (seriesList.length === 0) {
    return (
      <Card className="border-[#E5E4E0] bg-white">
        <CardContent className="p-4 text-center">
          <Layers className="w-8 h-8 text-[#5C5F5C] mx-auto mb-2" />
          <p className="text-sm text-[#5C5F5C]">No series yet</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-2">
      {seriesList.map((s) => (
        <Card
          key={s.id}
          className={`border-[#E5E4E0] bg-white cursor-pointer card-hover ${
            selectedSeries === s.id ? 'border-[#4B6651] ring-1 ring-[#4B6651]' : ''
          }`}
          onClick={() => onSelectSeries(s.id)}
          data-testid={`series-card-${s.id}`}
        >
          <CardContent className="p-3">
            <p className="text-sm font-medium text-[#2A2C2A] truncate">{s.series_name}</p>
            <p className="text-xs text-[#5C5F5C]">{s.slice_count} slice{s.slice_count !== 1 ? 's' : ''}</p>
            {s.modality && <p className="text-xs text-[#4B6651]">{s.modality}</p>}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default SeriesList;
